import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components';
import { AuthWrapper } from '@/features/core/auth/screens/AuthWrapper';

export const EventNotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AuthWrapper isHomepage={false}>
      <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 text-center space-y-8">
        {/* Ícone simples */}
        <div className="w-24 h-24 flex items-center justify-center rounded-full bg-gradient-to-r from-alert-info-soft to-[#4A90E2] text-white shadow-lg">
          <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        {/* Título e descrição */}
        <div className="space-y-2 max-w-md">
          <h1 className="text-4xl font-bold text-neutro-b-400">Evento Finalizado</h1>
          <p className="text-lg text-neutro-w-600">
            Ops! As vendas para este evento já foram encerradas ou o evento não está mais
            disponível.
          </p>
        </div>

        {/* Botões */}
        <div className="flex flex-col sm:flex-row gap-4">
          <Button
            title="Voltar para a Home"
            buttonStyle="primary"
            size="xlg"
            onClick={() => navigate('/')}
          />
          <Button
            title="Ver outros eventos"
            buttonStyle="outlined"
            size="xlg"
            onClick={() => navigate('/')}
          />
        </div>

        {/* Rodapé */}
        <div className="mt-12 text-sm text-[#BDBDBD] uppercase tracking-widest">
          BancadoIngresso &copy; {new Date().getFullYear()}
        </div>
      </div>
    </AuthWrapper>
  );
};
